import React from "react";

import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const CheckboxMinusIcon: FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props} viewboxSize="sm">
    <path d="M4 7a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2H4Z" />
  </BaseIcon>
);
